import React from 'react';
import { Button } from '@mui/material';

const OrderFooter = ({
    buttonType,
    intraday,
    overNight,
    isLoading,
    onSwipeComplete
}) => {
    const isBuy = buttonType === "buy";
    const primaryColor = isBuy ? "#089981" : "#f23645";
    const primaryColorLight = isBuy ? "#0899811a" : "#f236451a";
    const buttonBgColor = isBuy ? "#089981" : "#f23645";
    const borderColor = isBuy ? "#007928" : "#790000";

    return (
        <div className="space-y-10 p-4 fixed bottom-0 left-1/2 transform -translate-x-1/2 w-[100vh] max-w-[380px] pb-[20px] bg-white">
            <div className="flex items-center justify-between mt-1 space-x-4">
                <span
                    className="flex items-center font-lato justify-center w-[50%] h-[50px] text-center rounded-[3px] text-[12px]"
                    style={{ backgroundColor: primaryColorLight }}
                >
                    INTRADAY : {(intraday ?? 0).toFixed(2)}
                </span>

                <span
                    className="flex items-center font-lato justify-center w-[50%] h-[50px] text-center rounded-[3px] text-[12px]"
                    style={{ backgroundColor: primaryColorLight }}
                >
                    OVER NIGHT : {(overNight ?? 0).toFixed(2)}
                </span>
            </div>

            <div className="flex justify-center">
                <Button
                    disabled={isLoading}
                    className={`rounded-[8px] text-white py-4 px-[33px] text-[16px] font-semibold leading-[20px] flex flex-col items-center`}
                    style={{
                        backgroundColor: isLoading ? "#9ca3af" : buttonBgColor,
                        borderColor: borderColor
                    }}
                    onClick={onSwipeComplete}
                >
                    {isLoading ? "Processing..." : buttonType.toUpperCase()}
                </Button>
            </div>
        </div>
    );
};

export default OrderFooter;